import Divider from "../divider";

import styles from "./our-values.module.scss";

function OurValues() {
  return (
    <div className={styles.OurValues}>
      <Divider />
      <div className={styles.Content}>
        <h2>Our Values</h2>

        <h3>Put customers first</h3>

        <p>
          Be famous for friendly service. Care for people so that they can be
          their best. Focus on the customer and all else will follow.
        </p>

        <h3>Make a difference in our communities</h3>

        <p>
          Our locations are not insular, they are diverse connecting points for
          the broader community as well as our members. We strive to be a
          social, economic and cultural beacon in the neighbourhoods we inhabit.
        </p>

        <h3>We are one team</h3>

        <p>
          Our members and staff make the difference. By sharing our skills,
          knowledge and experience we become one team. Diversity makes us
          strong.
        </p>

        <h3>Strive for continuous improvement</h3>

        <p>
          Our work is never done. We work collectively to continuously improve
          our operations and productivity through a gradual, methodical and
          resourceful process.
        </p>
      </div>
    </div>
  );
}

export default OurValues;
